import { lazy, Suspense } from 'react';

import { Loading } from './loading';

const Settings = lazy(() => import('./settings'));

export function SettingsPage() {
  return (
    <article className="space-y-6" data-testid="settings-page">
      <Suspense fallback={<Loading />}>
        <Settings />
      </Suspense>
    </article>
  );
}
